"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importStar)(require("react"));
var asg_1 = require("@alinta-digital/asg");
var components_1 = require("../../../components");
var Clock_1 = require("../Icons/Clock");
var Failure_1 = require("../Icons/Failure");
var react_scroll_1 = require("react-scroll");
var myaccount_frontend_shared_1 = require("@alinta-digital/myaccount-frontend-shared");
var Success_1 = require("../Icons/Success");
var useGAOnLoad = function (success, paymentType, ga) {
    (0, react_1.useEffect)(function () {
        if ((ga === null || ga === void 0 ? void 0 : ga.eventName) === 'process.payment') {
            if (paymentType === 'paypal') {
                ga === null || ga === void 0 ? void 0 : ga.push(success ? 'load.0.paypalsuccess' : 'load.0.paypalfailure');
            }
            else {
                ga === null || ga === void 0 ? void 0 : ga.push(success ? 'success.0.paymentresponse' : 'error.0.paymentresponse');
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
var Receipt = function (_a) {
    var success = _a.success, receiptNumber = _a.receiptNumber, paymentType = _a.paymentType, ga = _a.ga;
    var responsiveSize = (0, react_1.useContext)(asg_1.ResponsiveContext);
    useGAOnLoad(success !== null && success !== void 0 ? success : false, paymentType, ga);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(asg_1.Box, { margin: { top: responsiveSize === 'lg' ? 'small' : '0px', bottom: '0px' }, width: "100%" },
            react_1.default.createElement(asg_1.Box, { margin: { horizontal: 'auto', vertical: 'small' } }, success ? (react_1.default.createElement(asg_1.Icon, { id: "responseIcon", icon: Success_1.SuccessIcon, height: "54px", width: "54px", "data-testid": "responseIcon" })) : (react_1.default.createElement(asg_1.Icon, { id: "responseIcon", icon: Failure_1.FailureIcon, height: "54px", width: "54px", "data-testid": "responseIcon" })))),
        react_1.default.createElement(asg_1.Box, null,
            react_1.default.createElement(asg_1.Heading, { level: "3", margin: { horizontal: 'auto', bottom: 'small' }, "data-testid": "responseHeader", weight: 700, color: asg_1.colors['colour-black'] }, success ? 'Payment success' : 'Payment unsuccessful')),
        success ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(asg_1.Box, { margin: { bottom: responsiveSize === 'lg' ? 'xsmall' : '16px' } },
                react_1.default.createElement(asg_1.Text, { textAlign: "center", size: "medium", weight: 600, "data-testid": "receiptTitle", color: asg_1.colors['colour-black'] }, "Payment receipt number"),
                react_1.default.createElement(asg_1.Text, { textAlign: "center", size: "medium", margin: { bottom: '4px' }, "data-testid": "receiptNumber", color: asg_1.colors['colour-black'] }, receiptNumber)),
            react_1.default.createElement(ProcessingStatement, null))) : (react_1.default.createElement(asg_1.Box, null,
            paymentType === 'paypal' && (react_1.default.createElement(asg_1.Text, { textAlign: "center", size: "medium", color: asg_1.colors.tertiaryText.light, margin: { bottom: 'xsmall' }, "data-testid": "responseTextPaypal" }, "Please check details or try again later")),
            paymentType === 'card' && (react_1.default.createElement(asg_1.Text, { textAlign: "center", size: "medium", color: asg_1.colors.tertiaryText.light, margin: { bottom: 'xsmall' }, "data-testid": "responseText" }, "Please check with your bank or try again later"))))));
};
var ProcessingStatement = function () {
    var responsiveSize = (0, react_1.useContext)(asg_1.ResponsiveContext);
    return (react_1.default.createElement(asg_1.Box, { border: 'all', round: "4px", width: "100%", height: "fit-content", margin: { horizontal: 'auto', bottom: 'small' }, pad: {
            vertical: 'small',
            horizontal: responsiveSize === 'lg' ? 'small' : responsiveSize === 'sm' ? 'medium' : 'large'
        }, style: { borderLeft: '6px solid #196CFF' }, direction: "row" },
        react_1.default.createElement(asg_1.Box, { width: "14%", margin: "auto", align: responsiveSize === 'xs' ? 'center' : 'start' },
            react_1.default.createElement(asg_1.Icon, { id: "clockIcon", icon: Clock_1.ClockIcon, height: "23.63px", width: "23.63px", "data-testid": "clockIcon" })),
        react_1.default.createElement(asg_1.Box, { direction: "column", width: "86%", pad: { horizontal: responsiveSize === 'xs' ? 'large' : '0px' } },
            react_1.default.createElement(asg_1.Text, { size: "medium", weight: 600, "data-testid": "processingPayment", color: asg_1.colors['colour-black'] }, "Processing payment."),
            react_1.default.createElement(asg_1.Text, { size: "medium", color: asg_1.colors.text.light, "data-testid": "responseText" }, "It can take up to 48 hours for your payment to appear on your account."))));
};
var PaymentConfirmation = function (_a) {
    var success = _a.success, receiptNumber = _a.receiptNumber, onSubmit = _a.onSubmit, paymentType = _a.paymentType, ga = _a.ga;
    var responsiveSize = (0, react_1.useContext)(asg_1.ResponsiveContext);
    var _b = (0, react_1.useContext)(asg_1.StepsContext), goToStep = _b.goToStep, completeStep = _b.completeStep;
    var isWebGA = (ga === null || ga === void 0 ? void 0 : ga.eventName) === 'process.web.payment';
    (0, myaccount_frontend_shared_1.useAnalyticsLoadV2)(ga, 'load.0.debitcreditsuccess', paymentType === 'card' && success && isWebGA);
    (0, myaccount_frontend_shared_1.useAnalyticsLoadV2)(ga, 'load.0.debitcreditfailure', paymentType === 'card' && !success && isWebGA);
    (0, myaccount_frontend_shared_1.useAnalyticsLoadV2)(ga, 'load.0.paypalsuccess', paymentType === 'paypal' && success && isWebGA);
    (0, myaccount_frontend_shared_1.useAnalyticsLoadV2)(ga, 'load.0.paypalfailure', paymentType === 'paypal' && !success && isWebGA);
    var contentProperties = {
        header: {
            hide: false,
            title: ''
        },
        footer: {
            hide: true
        }
    };
    (0, react_1.useEffect)(function () {
        react_scroll_1.scroller.scrollTo('top-element', {
            duration: 0,
            smooth: true,
            offset: -50
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var submit = function () {
        if (success) {
            if (onSubmit) {
                if ((ga === null || ga === void 0 ? void 0 : ga.eventName) === 'process.web.payment') {
                    ga === null || ga === void 0 ? void 0 : ga.push('click.1.returntohomepage');
                }
                if ((ga === null || ga === void 0 ? void 0 : ga.eventName) === 'process.payment') {
                    ga === null || ga === void 0 ? void 0 : ga.push('click.1.paymentresponse.returntohomepage');
                }
                onSubmit();
            }
        }
        else {
            if ((ga === null || ga === void 0 ? void 0 : ga.eventName) === 'process.payment') {
                ga === null || ga === void 0 ? void 0 : ga.push('click.1.paymentresponse.tryagain');
            }
            completeStep('step3');
            goToStep('step1');
            var url = new URL(window.location.href);
            var hasParams = url.searchParams.has('SessionID') || url.searchParams.has('SST');
            if (hasParams) {
                window.history.replaceState(undefined, '', url.pathname);
            }
        }
    };
    return (react_1.default.createElement(components_1.Content, (0, tslib_1.__assign)({}, contentProperties),
        react_1.default.createElement(react_scroll_1.Element, { name: "top-element" },
            react_1.default.createElement(asg_1.Box, { direction: "column", maxWidth: "416px", width: "100%", margin: "0 auto" },
                react_1.default.createElement(Receipt, { success: success, receiptNumber: receiptNumber, paymentType: paymentType, ga: ga }),
                react_1.default.createElement(asg_1.ButtonV2, { "data-testid": "returnButton", secondary: true, margin: {
                        horizontal: 'auto',
                        top: success ? '0px' : 'medium',
                        bottom: responsiveSize === 'xs' || responsiveSize === 'sm' ? 'xsmall' : 'large'
                    }, pad: { vertical: '21px' }, width: "100%", maxWidth: "416px", onClick: submit, style: { lineHeight: '16px' } }, success ? 'Return to homepage' : 'Try again')))));
};
exports.default = PaymentConfirmation;
//# sourceMappingURL=PaymentConfirmation.js.map